export const stripQualioHost = (str: string): string => {
  try {
    const url = new URL(str);
    if (url.host.includes('qualio')) {
      return url.pathname + url.search;
    }
  } catch {
    // ignore: not a valid URL (might be a relative URL (i.e. /path/to/page))
    return str;
  }
  return str;
};

/**
 * Returns an absolute URL suitable for copying/sharing. If the input is already
 * absolute it is returned unchanged; a relative path (i.e. /path/to/page) is
 * resolved against the current origin.
 */
export const toAbsoluteUrl = (str: string): string => {
  try {
    // Absolute URLs parse without a base; relative paths throw and fall through.
    return new URL(str).href;
  } catch {
    return `${window.location.origin}${str.startsWith('/') ? '' : '/'}${str}`;
  }
};
